module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"activateUser":"Activate User","activateUserMessage":"Enter your password","backToLogin":"Back to login","submit":"Submit"},"al":{"activateUser":"Aktivizo Perdoruesin","activateUserMessage":"Vendosni fjalekalimin tuaj","backToLogin":"Kthehu tek nderfaqja per tu kycur","submit":"Ruaj"}}')
  delete Component.options._Ctor
}
